import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';
import {
  ChurnBand,
  ChurnCalibrationDTO,
  ChurnListRowDTO,
  StudentChurnDTO,
} from '../clientTypes/DTOs/ChurnDTO';

const BASE_URL = '/churn';

export type ChurnSortField =
  | 'fullName'
  | 'score'
  | 'gradYear'
  | 'timeWithUs'
  | 'averageNPS'
  | 'updatedAt';

export const getChurnScores: ApiDescription = {
  endpoint: `${BASE_URL}/churn-scores`,
  method: RequestsMethod.Get,
};

export type GetChurnScores = ApiData<
  {
    page?: string;
    limit?: string;
    sortBy?: ChurnSortField;
    sortOrder?: 'asc' | 'desc';
    search?: string;
    userId?: string;
    userActiveStatus: 'indeterminate' | 'checked' | 'unchecked';
    graduationYears?: string[];
    averageScoreLevel?: ChurnBand;
    timeWithUsStart: number | undefined;
    timeWithUsEnd: number | undefined;
    resolvedStatus: 'indeterminate' | 'checked' | 'unchecked';
  },
  {
    users: ChurnListRowDTO[];
    total: number;
  }
>;

export const getStudentChurnScore: ApiDescription = {
  endpoint: `${BASE_URL}/student/:id`,
  method: RequestsMethod.Get,
};

export type GetStudentChurnScore = ApiData<never, StudentChurnDTO | null>;

export const getChurnCalibration: ApiDescription = {
  endpoint: `${BASE_URL}/calibration`,
  method: RequestsMethod.Get,
};

export type GetChurnCalibration = ApiData<never, ChurnCalibrationDTO>;

export const resolveChurn: ApiDescription = {
  endpoint: `${BASE_URL}/resolve/:id`,
  method: RequestsMethod.Put,
};

export type ResolveChurn = ApiData<unknown, unknown>;
